import { initializeFirstHeroVisibleMonitor } from './shared-monitors/javascript-start-to-hero-visible';
import { initializeFirstMarketingTileVisibleMonitor } from './shared-monitors/javascript-start-to-marketing-tile-visible';

export const initializeHomepagePerformanceMonitors = () => {
  initializeFirstHeroVisibleMonitor();
  initializeFirstMarketingTileVisibleMonitor();
};
